import {HttpService} from "../http/HttpService";
import {PushSubscription} from "../http/protocol";


export class NotificationsService {
    constructor(private http : HttpService) {}

    getPublicKey():Promise<string> {
        return this.http.get('/notifications/key');
    }

    subscribeTo(subscription:PushSubscription):Promise<Response> {
        console.log("subscribeTo", subscription);
        return this.http.post('/notifications/subscribe', subscription);
    }
    unSubscribeTo(subscription:PushSubscription):Promise<Response> {
        console.log("unSubscribeTo", subscription);
        return this.http.post('/notifications/unsubscribe', subscription);
    }

    getSubscription(endpoint: string): Promise<boolean> {
        return this.http.get(`/notifications/subscribing?endpoint=${encodeURIComponent(endpoint)}`)
            .then((response) => {
                console.log("getSubscription response", response);
                return response === true;
            })
            .catch((error) => {
                console.error('Error checking subscription:', error);
                return false;
            });
    }
}
